import Layout from '../Layout/Layout';
import { Container, Button, Row, Col } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const ErrorNoAccount = () => {
  const { t } = useTranslator();

  const {
    images: { noAccountErrorImg },
  } = useAppContext();

  return (
    <Layout>
      <div className="page-template-error">
        <section className="text-center d-flex align-items-center full-height">
          <Container>
            <Row>
              <Col md={{ size: 4, offset: 4 }}>
                <img
                  src={noAccountErrorImg}
                  className="img-fluid mb-xl"
                  width="343"
                  height="250"
                  alt=""
                />
                <h2 className="title-medium semi-bold">{t('noAccountError.title')}</h2>
                <p className="mb-xl text-text-variant-color">{t('noAccountError.content')}</p>
                <Button
                  color="primary"
                  className="w-100"
                  onClick={() => {
                    window.location = `${import.meta.env.VITE_LANDING_PAGE_URL}/#buy`;
                  }}
                >
                  {t('noAccountError.getAccess.button')}
                </Button>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
};

export default ErrorNoAccount;
